// Forum posts — Firestore service
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './config';

const COL = 'posts';

/** Fetch all posts ordered newest-first */
export async function fetchPosts() {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

/** Add a new pending post */
export async function addPost(data) {
  const ref = await addDoc(collection(db, COL), {
    ...data,
    status: 'pending',
    hearts: 0,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

/** Approve a post */
export async function approvePost(id) {
  await updateDoc(doc(db, COL, id), { status: 'approved' });
}

/** Delete / reject a post */
export async function deletePost(id) {
  await deleteDoc(doc(db, COL, id));
}

/** Increment heart count */
export async function heartPost(id, currentHearts) {
  await updateDoc(doc(db, COL, id), { hearts: currentHearts + 1 });
}
